import { render, staticRenderFns } from "./appTodoView.vue?vue&type=template&id=db99e284"
import script from "./appTodoView.vue?vue&type=script&lang=js"
export * from "./appTodoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports